/* eslint-disable sonarjs/no-duplicate-string */

import caaavLogo from 'src/client/assets/images/withLove/caaav-logo.png';
import donorOrganizerHubLogo from 'src/client/assets/images/withLove/donor-organizer-hub-logo.png';
import fromWithLovePart1Graphic from 'src/client/assets/images/withLove/from-with-love-1.gif';
import fromWithLovePart2Graphic from 'src/client/assets/images/withLove/from-with-love-2.gif';
import fromWithLovePart3Graphic from 'src/client/assets/images/withLove/from-with-love-3.gif';
import handInHandLogo from 'src/client/assets/images/withLove/hand-in-hand-logo.png';
import katalyFoundationLogo from 'src/client/assets/images/withLove/kataly-featured-logo.png';
import kelloggFoundationLogo from 'src/client/assets/images/withLove/kellogg-foundation-logo.png';
import mertzGilmoreFoundationLogo from 'src/client/assets/images/withLove/mertz-gillmore-logo.png';
import resonanceNetworkLogo from 'src/client/assets/images/withLove/resonance-network-logo.png';
import risingMajorityLogo from 'src/client/assets/images/withLove/rising-majority.png';
import ellaBakerCenterLogo from 'src/client/assets/images/withLove/surj-logo.png';
import tenantsTogetherLogo from 'src/client/assets/images/withLove/tenants-together-logo.png';

import { OrganizationCard } from './types';

export const WITH_LOVE_VIMEO_URL =
  'https://player.vimeo.com/video/1147523249?autoplay=1&controls=1&title=0&byline=0&portrait=0';

// All organization cards data
export const allOrganizationCards: OrganizationCard[] = [
  {
    id: '1',
    name: 'Rising Majority',
    logoUrl: risingMajorityLogo,
    authorName: 'Mandy',
    authorTitle: 'Development Director',
    welcomeMessage:
      'Dear friend - I remember Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris',
    letterUrl: 'https://therisingmajority.com',
    isFeatured: true,
  },
  {
    id: '2',
    name: 'Hand in Hand: The Domestic Employers Network',
    logoUrl: handInHandLogo,
    authorName: 'Sarah',
    authorTitle: 'Executive Director',
    welcomeMessage:
      'Dear friend - I remember Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris',
    letterUrl: '#',
    isFeatured: false,
  },
  {
    id: '3',
    name: 'Resonance Network',
    logoUrl: resonanceNetworkLogo,
    authorName: 'James',
    authorTitle: 'Co-Founder',
    welcomeMessage:
      'Dear friend - I remember Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris',
    letterUrl: '#',
    isFeatured: false,
  },
  {
    id: '4',
    name: 'CAAAV: Organizing Asian Communities',
    logoUrl: caaavLogo,
    authorName: 'Maria',
    authorTitle: 'Community Organizer',
    welcomeMessage:
      'Dear friend - I remember Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris',
    letterUrl: '#',
    isFeatured: false,
  },
  {
    id: '5',
    name: 'Tenants Together',
    logoUrl: tenantsTogetherLogo,
    authorName: 'David',
    authorTitle: 'Policy Director',
    welcomeMessage:
      'Dear friend - I remember Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris',
    letterUrl: '#',
    isFeatured: false,
  },
  {
    id: '6',
    name: 'Donor Organizer Hub',
    logoUrl: donorOrganizerHubLogo,
    authorName: 'Rachel',
    authorTitle: 'Program Manager',
    welcomeMessage:
      'Dear friend - I remember Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris',
    letterUrl: '#',
    isFeatured: false,
  },
  {
    id: '7',
    name: 'Ella Baker Center for Human Rights',
    logoUrl: ellaBakerCenterLogo,
    authorName: 'Michael',
    authorTitle: 'Communications Director',
    welcomeMessage:
      'Dear friend - I remember Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris',
    letterUrl: '#',
    isFeatured: false,
  },
];

export const storyContent = [
  {
    id: '1',
    bodyText: `"We know, love and admire the groups we've shared with you through the letter that helped you find your way here, and, we know and love you. 
  
  Starting today, and with this shared thank you letter template, we choose to be connectors. 
  
  This is a warm introduction to organizations whose success is intertwined with our own."`,
    subtitle: 'From With Love - Part 1',
    imageUrl: fromWithLovePart1Graphic,
  },
  {
    id: '2',
    bodyText: `"We believe that it is critical that everyone is able to be celebrated for the way that their individual, sometimes seemingly discrete acts, add up to something larger, 
  
  add up to a powerful civic and political identity, add up to a version of yourself full of values, and agency, and purpose, overflowing with possibility both for the person themself, 
  
  but also for the communities and legacies that they become a part of through their shared identity."`,
    subtitle: 'From With Love - Part 2',
    imageUrl: fromWithLovePart2Graphic,
  },
  {
    id: '3',
    bodyText: `"What  breathes life and possibility into our movements, and what makes our movements captivating and irreversible are the people and communities we get to know and be a part of through the ways in which our civic and political journeys overlap and have us traveling together.
  
  We want you to know that you deserve, and strong democracies and vibrant movements need us all to have, civic and political homes."`,
    subtitle: 'From With Love - Part 3',
    imageUrl: fromWithLovePart3Graphic,
  },
];

// Footer supporter organizations
export const supporterOrganizations = [
  {
    id: '1',
    name: 'W.K. Kellogg Foundation',
    logoUrl: kelloggFoundationLogo,
  },
  {
    id: '2',
    name: 'Kataly Foundation',
    logoUrl: katalyFoundationLogo,
  },
  {
    id: '3',
    name: 'Mertz Gilmore Foundation',
    logoUrl: mertzGilmoreFoundationLogo,
  },
];
